import { useMutation } from "react-query";
import { ParceiroDisponibilidadeItem } from "../typings";
import http from "infra/http";

function useSaveDisponibilidadeParceiro(
id: string
) {
  return useMutation(
    (data:{items: ParceiroDisponibilidadeItem[]}) => {

      return http.post(
        `/v1/parceiro/${id}/disponibilidade`,
        data
      );
    },
    { retry: false }
  );
}

export default useSaveDisponibilidadeParceiro;
